(function(){
function init(){
  var root=document.getElementById('ShRoot'); if(!root||root.dataset.ready) return; root.dataset.ready='1';
  var $=function(s){return document.querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var portal=document.getElementById('ShPortal');
  $$('body > .sh-portal').forEach(function(p){if(p!==portal)p.remove()});
  if(portal&&portal.parentNode!==document.body)document.body.appendChild(portal);
  var hover=window.matchMedia('(hover:hover)'), desk=window.matchMedia('(min-width:1000px)');
  var hdr=$('#ShHdr'), scrim=$('#ShScrim'), drop=$('#ShDrop'), shopBtn=$('[data-sh-shop]'), search=$('#ShSearch'), drawerEl=$('#ShDrawer'), dscrim=$('#ShDscrim');
  var t=null;

  var onScroll=function(){root.classList.toggle('is-scrolled',window.scrollY>4)}; onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  function panel(name){
    var shop=name==='shop', srch=name==='search';
    drop.classList.toggle('is-show',shop); shopBtn.classList.toggle('is-open',shop); shopBtn.setAttribute('aria-expanded',shop);
    search.classList.toggle('is-show',srch); $$('[data-sh-search]').forEach(function(b){b.setAttribute('aria-expanded',srch)});
    scrim.classList.toggle('is-show',!!name);
    if(srch) setTimeout(function(){$('#ShQ').focus()},60);
  }
  var isOpen=function(el){return el.classList.contains('is-show')};
  shopBtn.addEventListener('click',function(){panel(isOpen(drop)?null:'shop')});
  shopBtn.addEventListener('mouseenter',function(){if(!hover.matches)return;clearTimeout(t);t=setTimeout(function(){panel('shop')},80)});
  shopBtn.addEventListener('mouseleave',function(){clearTimeout(t)});
  drop.addEventListener('mouseenter',function(){clearTimeout(t)});
  hdr.addEventListener('mouseleave',function(){if(hover.matches&&isOpen(drop)){clearTimeout(t);t=setTimeout(function(){panel(null)},180)}});
  $$('.sh-nav a').forEach(function(a){a.addEventListener('mouseenter',function(){if(hover.matches&&isOpen(drop))panel(null)})});
  scrim.addEventListener('click',function(){panel(null)});
  $$('[data-sh-search]').forEach(function(b){b.addEventListener('click',function(){panel(isOpen(search)?null:'search')})});

  var q=$('#ShQ'), res=$('#ShRes'), st=null, ctl=null;
  var esc=function(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML};
  q.addEventListener('input',function(){
    clearTimeout(st); var v=q.value.trim();
    if(v.length<2){res.innerHTML='';return}
    st=setTimeout(function(){
      if(ctl)ctl.abort(); ctl=window.AbortController?new AbortController():null;
      fetch(root.dataset.suggest+'.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=5',ctl?{signal:ctl.signal}:{})
        .then(function(r){return r.json()}).then(function(d){
          var p=(d.resources&&d.resources.results&&d.resources.results.products)||[];
          res.innerHTML=p.map(function(x){return '<a href="'+x.url+'">'+(x.image?'<img src="'+x.image+(x.image.indexOf('?')>-1?'&':'?')+'width=120" alt="" loading="lazy">':'<i></i>')+'<b>'+esc(x.title)+'</b></a>'}).join('')
            +(p.length?'<a class="sh-sall" href="'+root.dataset.search+'?q='+encodeURIComponent(v)+'&options%5Bprefix%5D=last">'+esc(root.dataset.all)+'</a>':'<p class="sh-sall">'+esc(root.dataset.none)+'</p>');
        }).catch(function(){});
    },220);
  });

  function drawer(on){
    drawerEl.classList.toggle('is-show',on); dscrim.classList.toggle('is-show',on);
    drawerEl.setAttribute('aria-hidden',!on);
    $$('[data-sh-drawer]').forEach(function(b){b.setAttribute('aria-expanded',on)});
    document.documentElement.style.overflow=on?'hidden':'';
    if(on)panel(null);
  }
  $$('[data-sh-drawer]').forEach(function(b){b.addEventListener('click',function(){drawer(true)})});
  dscrim.addEventListener('click',function(){drawer(false)});
  $$('[data-close]',drawerEl).forEach(function(a){a.addEventListener('click',function(){drawer(false)})});
  $$('[data-sh-acc]',drawerEl).forEach(function(b){b.addEventListener('click',function(){
    var sub=document.getElementById(b.getAttribute('aria-controls')), on=!sub.classList.contains('is-open');
    sub.classList.toggle('is-open',on); b.setAttribute('aria-expanded',on);
  })});
  if(desk.addEventListener)desk.addEventListener('change',function(e){if(e.matches)drawer(false);else panel(null)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){panel(null);drawer(false)}});
  document.addEventListener('click',function(e){if(!root.contains(e.target)&&(isOpen(drop)||isOpen(search)))panel(null)});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();